import { render, staticRenderFns } from "./details.modal.vue?vue&type=template&id=5b6d4a0a&scoped=true&"
import script from "./details.modal.vue?vue&type=script&lang=js&"
export * from "./details.modal.vue?vue&type=script&lang=js&"
import style0 from "./details.modal.vue?vue&type=style&index=0&id=5b6d4a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d4a0a",
  null
  
)

export default component.exports